var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhormulaLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 598.9 94.7",
    style: {
      enableBackground: "new 0 0 598.9 94.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#221F20;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.4,16.2h32.1c13.1,0,24.4,7.7,24.4,24.5c0,15.1-11.3,24.1-24.4,24.1H21.3v18.6H7.4V16.2z M21.3,28.3v24.5 h16.1c6.8,0,12.3-4.6,12.3-12.2c0-8-5.4-12.4-12.3-12.4H21.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.2,55.6H89.1v27.9H75.2V16.2h13.8v27.3h36.1V16.2H139v67.2h-13.8V55.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M185.5,15.2c19.9,0,34.7,14.8,34.7,34.7c0,19.7-14.8,34.5-34.7,34.5c-19.7,0-34.5-14.8-34.5-34.5 C151,30,165.8,15.2,185.5,15.2z M185.6,71.5c12.4,0,21-9.4,21-21.6c0-12.4-8.6-21.6-21-21.6c-12.2,0-21,9.2-21,21.6 C164.6,62.1,173.4,71.5,185.6,71.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M232.2,16.2h29.6c16.5,0,26.8,6.7,26.8,21.8c0,10.7-7.6,18.6-17.7,20.7l21.5,22.4v2.3h-15.5l-22.4-24.2h-8.3 v24.2h-13.8V16.2z M246.1,28.3v20.1h17.2c6.3,0,10.9-3.8,10.9-10c0-6.6-4.5-10.1-10.9-10.1H246.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M364.1,38.1l-22.5,27.1h-2.5l-22.4-27.1v45.4h-13.8V16.2h12.5l25.1,30l25.1-30H378v67.2h-13.8V38.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M406.4,54.2c0,10.7,5.4,17.5,16.6,17.5c11.4,0,16.9-7.2,16.9-17.6V16.2h13.8v38.9c0,15.8-10.7,29.5-30.7,29.5 c-19.9,0-30.4-12.4-30.4-29.5V16.2h13.8V54.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M469,83.4V16.2h13.8v55.2h34.9v12.1H469z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M550.5,16.2h16.2l26,67.2h-14L573.5,70H543l-5.2,13.4h-14L550.5,16.2z M546.5,59.7H570l-11.5-29.8L546.5,59.7 z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhormulaLogo);
export default __webpack_public_path__ + "static/media/phormula-logo.77a54a2374e7b967ec54ebc683b0cfcf.svg";
export { ForwardRef as ReactComponent };